export default {
  HOME: '/',
}